import { Link, matchPath, useLocation } from "react-router-dom";
import { Home, Library, Workflow, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export type NavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
};

// MJOS-188 — Engineering Dashboard sidebar.
//
// The generic MJOS furniture (Goals / Projects / Tickets / Agents / Skills /
// Memory) is REMOVED here so the post-login experience is the client's, not
// ours. Only client-relevant entries are surfaced:
//
//   - Home          → the live Engineering Dashboard for this client's station
//   - Knowledge Base → /knowledge-base index (kept; useful client-facing docs)
//
// Detail routes (/zeus/:id, /kb-doc/*, /settings, etc.) stay registered in
// CRM.tsx but are not in the sidebar — they're reached from the dashboard or
// from links inside KB pages.
export const navItems: NavItem[] = [
  { label: "Home", to: "/home", icon: Home },
  { label: "Process", to: "/process", icon: Workflow },
  { label: "Knowledge Base", to: "/knowledge-base", icon: Library },
];

export function NavLink({ item }: { item: NavItem }) {
  const location = useLocation();
  const active =
    item.to === "/"
      ? location.pathname === "/"
      : !!matchPath(item.to + "/*", location.pathname);

  return (
    <Link
      to={item.to}
      className={cn(
        "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors",
        active
          ? "bg-accent text-foreground font-medium"
          : "text-muted-foreground hover:bg-accent hover:text-foreground",
      )}
    >
      <item.icon className="h-[18px] w-[18px]" />
      <span>{item.label}</span>
    </Link>
  );
}
